const EN_LINEA = '1'
const DIFERIDO = '2'

const __dictionary = {
  [EN_LINEA]: {
    id: EN_LINEA,
    nombre: 'EN LINEA'
  },
  [DIFERIDO]: {
    id: DIFERIDO,
    nombre: 'DIFERIDO'
  }
}

const __array = [__dictionary[EN_LINEA], __dictionary[DIFERIDO]]

export default Object.freeze({
  EN_LINEA,
  DIFERIDO,
  __dictionary,
  __array
})
